import * as React from 'react';

interface IProps {
    text: string;
}

const styles: Record<string, React.CSSProperties> = {
    seoText: {
        width: '90%',
        margin: '0 auto',
        fontWeight: 'bold',
        fontSize: 16,
        lineHeight: 1.4,
    },
};

export const NewletterFooter = (props: IProps) => {
    return (
        <div className="NewsletterFooterWrapper">
            <div style={styles.seoText} dangerouslySetInnerHTML={{ __html: props.text }} />
        </div>
    );
};
